import { ACTIVITY_STATE_ALL_VALUE } from "components/filters/ToggleActivityStateFilter";
import { AppList } from "components/list/AppList";
import React from "react";
import { Datagrid, EditButton, EmailField, TextField } from "react-admin";

import { DatagridWithBlockProps } from "../../../components/_helpers/props/DatagridProps";
import { CopyField } from "../../../components/fields/CopyField";
import { PhoneField } from "../../../components/fields/PhoneField";
import { PriceCategoryField } from "../../../components/fields/PriceCategoryField";
import { SelectEnumField } from "../../../components/fields/SelectEnumField";
import { YesNoField } from "../../../components/fields/YesNoField";
import { ScrollingWrapper } from "../../../components/ScrollingWrapper";
// import { CompanyExpandPanel } from './ItemExpand';
import BlockUnblockButton from "../../../components/toolbars/BlockUnblockButton";
import { CompanyCustomerType } from "../../../entities";
import { CustomerCompanyActions } from "./Actions";
import { CompaniesFilter } from "./ListFilters";

const defaultSort = { field: "id", order: "DESC" };
const filterDefaultValues = { activity_state: ACTIVITY_STATE_ALL_VALUE };

export const CompaniesList = (props) => {
	return (
		<AppList
			{...props}
			exporter={false}
			bulkActionButtons={false}
			filters={<CompaniesFilter />}
			filterDefaultValues={filterDefaultValues}
			sort={defaultSort}
			actions={<CustomerCompanyActions />}
		>
			<ScrollingWrapper>
				<Datagrid
					{...DatagridWithBlockProps}
					// expand={<CompanyExpandPanel />}
					rowClick="show"
				>
					<TextField source="id" />
					<TextField source="full_name" />
					<TextField source="short_name" />
					<TextField source="accountancy_number" />
					<EmailField source="email" />
					<PhoneField source="phone" />
					<PriceCategoryField source="price_category" />
					<YesNoField source="set_order_completed" />
					<TextField source="currency" />
					<SelectEnumField source="type" enumObj={CompanyCustomerType} enumName={'company-type'}/>
					<CopyField
						source="guid"
						variant="button"
						style={{
							width: "250px",
							whiteSpace: "nowrap",
							overflow: "hidden",
							textOverflow: "ellipsis",
							display: "inline-block",
						}}
					/>
					<EditButton label="" />
					<BlockUnblockButton entity="company" />
				</Datagrid>
			</ScrollingWrapper>
		</AppList>
	);
};
